<template>
  <div>
    <div class="headClass">
    </div>
    <div id="commoon_header">
      <div class="r_bar">
        <div class="width_w clearfix">
          <ul class="left">
            <li><a href="#">您好，欢迎关注和使用荷云采！</a></li>
          </ul>

          <ul class="yqlj right">
            <li><a target="_blank" href="https://www.holdsteel.com/">荷钢网</a></li>
            <li><a target="_blank" href="https://www.holdcg.com/">荷云采</a></li>
<!--            <li><a target="_blank" href="http://www.holdtms.com/">荷智运</a></li>-->
            <li><a target="_blank" href="https://admin.holdsteel.com/gdpaas/login/index.htm">荷云仓</a></li>
          </ul>
          <ul class="right nav-login">
            <li>
              <router-link class="router_home" to="/">
                <svg t="1672905284649" class="icon" viewBox="0 0 1078 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="31032" width="25" height="16" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M879.74227 494.221646C870.158228 494.221646 862.379876 501.999999 862.379876 511.58404L862.379876 894.737354C862.379876 936.846945 828.118086 971.108735 786.00849 971.108735L651.114264 971.108735 651.114264 705.209457C651.114264 695.625415 643.335912 687.847063 633.75187 687.847063L444.108227 687.847063C434.524186 687.847063 426.745833 695.625415 426.745833 705.209457L426.745833 971.108735 291.805307 971.108735C249.718864 971.108735 215.480223 936.846945 215.480223 894.737354L215.480223 511.58404C215.480223 501.999999 207.70187 494.221646 198.117829 494.221646 188.533787 494.221646 180.755434 501.999999 180.755434 511.58404L180.755434 894.737354C180.755434 955.991875 230.573931 1005.833523 291.805307 1005.833523L786.00849 1005.833523C847.263016 1005.833523 897.104664 955.991875 897.104664 894.737354L897.104664 511.58404C897.104664 501.999999 889.326312 494.221646 879.74227 494.221646L879.74227 494.221646ZM461.470621 722.571851 616.389476 722.571851 616.389476 971.085587 461.470621 971.085587 461.470621 722.571851ZM1051.305871 365.716781 925.810489 275.223983C909.39724 263.324955 894.974874 235.221027 894.974874 215.08065L894.974874 66.273358C894.974874 30.877224 866.176453 2.0788 830.803467 2.0788L786.749284 2.0788C751.399451 2.0788 722.647326 30.877224 722.647326 66.273358L722.647326 115.721456C722.647326 122.064518 721.165738 124.9351 721.003687 125.166599 720.471239 125.166599 717.48491 124.9814 712.114144 121.092224L582.336032 27.451045C566.594129 16.038165 553.884855 6.824521 551.153174 4.717884 547.796442 1.824152 543.189623-0.120436 538.906899 0.018463 534.855674-0.213036 530.133102 1.754702 526.776373 4.671584 523.790041 6.98657 508.071287 18.376301 489.5514 31.803219L26.600526 365.716781C12.71061 375.763819 3.566416 390.626029 0.834733 407.618025-1.896951 424.586872 2.131125 441.555718 12.108714 455.306734L29.725756 479.845584C41.578484 496.328284 60.491919 505.773426 81.60459 505.773426L81.62774 505.773426C83.850126 505.773426 86.095662 505.657677 88.341199 505.449328 91.39698 505.14838 94.313862 504.060336 96.814047 502.254648L538.930049 183.272744 981.1155 502.254648C983.615682 504.060336 986.532568 505.14838 989.588351 505.449328 991.833886 505.657677 994.079421 505.773426 996.324956 505.773426 1017.50708 505.773426 1036.397363 496.305134 1048.064889 479.868734L1065.774533 455.329884C1086.493658 426.600909 1079.988547 386.412754 1051.305871 365.716781L1051.305871 365.716781ZM1037.624304 435.004308 1019.845212 459.658907C1014.844842 466.650165 1006.626644 470.793989 997.204652 471.048638L549.231735 147.87661 549.208587 147.89976C543.397969 143.663336 534.369526 143.501287 528.350563 148.108109L80.724895 471.048638C71.279753 470.793989 63.015253 466.650165 57.922285 459.566308L40.282092 434.981158C35.69842 428.684396 33.869581 420.929194 35.119674 413.127691 36.369766 405.303039 40.55989 398.473831 46.926102 393.890158L509.923276 59.953447C523.558542 50.045307 532.679587 43.424448 538.906899 38.794476 544.185069 42.683652 551.569871 48.00812 561.941008 55.554974L691.811716 149.288751C701.604104 156.303159 711.419645 159.891387 721.003687 159.891387 739.106875 159.891387 757.372114 146.232971 757.372114 115.721456L757.372114 66.273358C757.372114 50.022157 770.544387 36.803588 786.749284 36.803588L830.803467 36.803588C847.031517 36.803588 860.250085 50.022157 860.250085 66.273358L860.250085 215.08065C860.250085 246.24036 880.112667 285.016373 905.484913 303.374211L1031.003443 393.890158C1044.152563 403.381601 1047.115749 421.832038 1037.624304 435.004308L1037.624304 435.004308Z" fill="#82868E" p-id="31033"></path></svg>
              </router-link>
            </li>
            <li v-if="!userLoginFlag">
              <a :href="this.memberThree+'/ebidding/#/login'">登录</a>
<!--              <a :href="this.member+'/member/login/function.htm?no_sitemesh'">登录</a>-->
            </li>
            <li v-if="!userLoginFlag">
              <a :href="this.memberThree + '/ebidding/#/ls/account'">注册</a>
            </li>
            <li v-if="userLoginFlag">
              <a :href="this.member+'/member/login/executeLogin.htm'">欢迎您，{{ userInfo.trueName }}</a>
            </li>
            <li v-if="userLoginFlag">
              <a :href="this.member+'/member/login/executeLogin.htm'">进入后台</a>
            </li>
            <li v-if="userLoginFlag && userInfo.isSyncVc =='1'">
              <a :href="this.member+'/member/login/ruoyiBlank.htm'">数字化采购专区</a>
            </li>
          </ul>
        </div>
      </div>
      <!--logo-->
      <div style="background: white">
        <div class="r_header clearfix">
          <ul class="menu_ul clearfix left hyc-home" @click="home">
            <li>
              <img class="r_logo left" src="../../../assets/image/pc/cms_logo.png"/>
              <span class="login-span"><img src="../../../assets/image/pc/zhaocai.png" alt=""></span>
            </li>
          </ul>
          <ul class="menu_ul right clearfix menu_ul_new">
            <!-- <li class="right categoryItem">
              <router-link class="one_a" to="/">首页</router-link>
            </li> -->
            <li class="right categoryItem">
              <router-link class="one_a" to="/purchase">招采公告</router-link>
            </li>
            <li class="right categoryItem">
              <a class="one_a" target="_blank"
                 href="https://client.holdsteel.com/marketpt/bidsaloon/items/index.htm">电子卖场</a>
            </li>
            <li class="right categoryItem">
              <a v-if="!isMobile" class="one_a" target="_blank" href="https://mall.holdcg.com">直采商城</a>
              <a v-if="isMobile" class="one_a" target="_blank" href="https://mall.holdcg.com/h5/#/pages/index/index">直采商城</a>
            </li>
            <li class="right categoryItem">
              <a class="one_a" target="_blank"
                 href="https://hunan.kuazongfu.cn">内外贸一体化</a>
            </li>
            <!--  pc端显示的，在sm及以下屏幕隐藏    小于 768px      -->
<!--            <li class="right categoryItem cms-ssm-hidden cms-sm-hidden">-->
<!--              <a class="one_a" target="_blank" href="https://fl.holdcg.com//#/mall">员工易购</a>-->
<!--            </li>-->
            <!--  手机端显示的，在sm及以下屏幕显示    小于 768px      -->
<!--            <li class="right categoryItem cms-md-hidden cms-lg-hidden cms-xl-hidden">-->
<!--              <a class="one_a" target="_blank" href="https://fl.holdcg.com/h5/#/">员工易购</a>-->
<!--            </li>-->

<!--            &lt;!&ndash;  pc端显示的，在sm及以下屏幕隐藏    小于 768px      &ndash;&gt;-->
<!--            <li class="right categoryItem cms-ssm-hidden cms-sm-hidden">-->
<!--               <a class="one_a" target="_blank" href="https://www.517la.com/">差旅专区</a>-->
<!--              <span class="one_a">差旅专区</span>-->
<!--            </li>-->
<!--            &lt;!&ndash;  手机端显示的，在sm及以下屏幕显示    小于 768px      &ndash;&gt;-->
<!--            <li class="right categoryItem cms-md-hidden cms-lg-hidden cms-xl-hidden">-->
<!--               <a class="one_a" target="_blank" href="">差旅专区</a>-->
<!--              <span class="one_a">差旅专区</span>-->
<!--            </li>-->
            <li class="right categoryItem">
              <a class="one_a" target="_blank" href="https://ct.ctrip.com/login?lang=zh-cn">商旅服务</a>
            </li>

            <li class="right categoryItem ">
              <router-link class="one_a" to="/zone-home">名企专区</router-link>
            </li>
            <li class="right categoryItem ">
              <a class="one_a" target="_blank" href="https://hycjf.zcjb.com.cn/#/">电子保函</a>
            </li>
            <!-- <li class="right categoryItem cms-ssm-hidden cms-sm-hidden">
              <router-link class="one_a" to="/information">资讯中心</router-link>
            </li> -->
            <!--          <li class="right categoryItem cms-ssm-hidden cms-sm-hidden">-->
            <!--          <router-link class="one_a" to="/information">平台介绍</router-link>-->
            <!--          </li>-->
            <!--          <li class="right categoryItem cms-ssm-hidden cms-sm-hidden" >-->
            <!--          <router-link class="one_a" to="/member">会员中心</router-link>-->
            <!--          </li>-->
            <!-- <li class="right categoryItem cms-ssm-hidden">
              <router-link class="one_a" to="/solution">解决方案</router-link>
            </li> -->
            <!-- <li class="right categoryItem">
              <router-link class="one_a" to="/help">帮助中心</router-link>
            </li> -->
          </ul>
        </div>
      </div>
      <!--导航栏-->
    </div>
    <!-- 右侧导航栏 -->
    <div class="commoon_header_right">
      <li>
        <router-link  to="/information"><i class="el-icon-document" style="font-size:16px;"></i>资讯中心</router-link>
      </li>
      <li>
        <router-link  to="/solution"><i class="el-icon-upload" style="font-size:18px;"></i>解决方案</router-link>
      </li>
      <li>
        <router-link  to="/help"><i class="el-icon-question" style="font-size:18px;"></i>帮助中心</router-link>
      </li>
    </div>
  </div>
</template>

<script>
import {getUserInfo} from "../../../api/commoon/user";

export default {
  name: "cms-header", data() {
    return {
      userInfo: {},
      userLoginFlag: false,
      isMobile:false,
      categoryList: [],
    }
  }, created() {
    let out = this.getParameter("logout");
    if (out != null && out != undefined && out != "") {
      this.$http.post(this.member + "/member/login/logout").then(res => {
        console.log(res);
      })
      window.reload();
    }
    this.selectCategoryList("nav", "categoryList");
    this.checkUser(this.getCookie("uuid"));
  }, methods: {
    getParameter: function (paraName) {
      let url = document.location.toString();
      //去除路由的#号
      if (url.lastIndexOf('#') == (url.length - 1)) {
        url = url.substring(0, url.lastIndexOf('#'));
      }
      let arrObj = url.split("?");
      if (arrObj.length > 1) {
        let arrPara = arrObj[1].split("&");
        let arr;
        for (let i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
    selectCategoryList: function (modelId, name) {
      var that = this;
      that.$http.get(that.base + "/category/list.do", {
        params: {
          modelId: modelId
        }
      }).then(function (data) {
        that[name] = data.data.result;
      }).catch(function (error) {

      })
    },
    //判断用户是否登入
    checkUser: function (uuid) {
      let that = this;
      getUserInfo(that.member).then(function (res) {
        that.userInfo = res.data.data;
        if (that.userInfo.isLogin == '1') {
          that["userLoginFlag"] = true;
        } else {
          that["userLoginFlag"] = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    //从cookie获取值
    getCookie: function (name) {
      var that = this;
      var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = document.cookie.match(reg)) {
        return (arr[2]);
      } else
        return null;
    },
    setHeadHeight: function () {
      let head = document.getElementById("commoon_header").offsetHeight;
      document.getElementsByClassName("headClass")[0].style.height = head + "px";
    },
    home:function () {
      let home = {'path': '/'};
      this.$router.push(home);
    }
  }, mounted() {
    this.setHeadHeight();

    let mobile = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );

    if (mobile != null) {
      this.isMobile = true
      console.log(this.isMobile)
    }else {
      this.isMobile = false
      console.log(this.isMobile)
    }

    window.addEventListener('resize', () => {
      this.setHeadHeight();
    }, true);
  }
}
</script>
<style scoped lang="css" src="../../../assets/commoon/css/common.css"></style>

<style scoped lang="scss">
.hyc-home{
  cursor: pointer;
}
.router_home{
  display: flex !important;
  align-items: center;
  color: #82868E;
}

.commoon_header_right>li>a{
  color: #606266;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #DCDFE6;
  padding-bottom: 10px;
  gap: 5px;
}
.commoon_header_right>li{
  list-style: none;
}
.commoon_header_right>li::marker{
  content: '';
}

.commoon_header_right{
  $border-width:12px;
  position: fixed;
  top: calc(50% - 102px);
  z-index: 999;
  right: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #fff;
  padding: 15px 10px;
  clip-path: polygon(0 #{$border-width},#{$border-width} 0, #{calc(100% - #{$border-width})} 0, 100% #{$border-width}, 100% #{calc(100% - #{$border-width})}, #{calc(100% - #{$border-width})} 100%, #{$border-width} 100%, 0 #{calc(100% - #{$border-width})});
}
</style>
<style scoped>
#commoon_header {
  position: fixed;
  z-index: 100;
  width: 100%;
  top: 0;
}

.ol, ul, dl {
  margin-bottom: 0px !important;
}

.menu_ul_new {
  display: flex;
  width: 800px;
}

.r_header {
  border: none;
  padding-top: 10px;
  padding-bottom: 1px;
}

.menu_ul li {
  padding-right: 0px;
  padding-left: 25px;
}

.menu_ul li:first-child {
  padding-right: 0px;
  padding-left: 0px;
}

ul {
  padding: 0px;
}

.login-span {
  font-size: 1.2rem;
  font-family: MicrosoftYaHei;
  color: #696969;
  line-height: 16px;
  letter-spacing: 1px;
  height: 50px;
  display: flex;
  align-items: center;
}

.yqlj {
  display: block;
}

.nav-login {
  margin-right: 20px;
}

@media screen and (max-width: 768px) {
  .menu_ul {
    width: 100% !important;
    float: none;
  }

  .menu_ul_new li:first-child {
    /*width: 100%;*/
  }

  .menu_ul li {
    padding-left: 2px;
  }

  .r_header {
    width: 100%;
  }

  .yqlj {
    display: none !important;
  }
}

@media screen and (max-width: 450px) {
  .menu_ul li {
    padding: 0px;
  }

  .menu_ul li .one_a {
    font-size: 1.3rem;
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .menu_ul {
    float: none;
  }

  .menu_ul li:first-child {
    width: 100%;
  }

  .menu_ul li {
    padding-left: 2px;
    padding-right: 13px !important;
  }

  .yqlj {
    display: block;
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  .menu_ul li:first-child {
    width: 100%;
    padding-left: 0px !important;
  }

  .menu_ul li:nth-child(2) {
    padding-left: 0px !important;
  }

  .menu_ul li {
    padding-right: 0px;
    padding-left: 25px !important;
  }
}

.menu_ul {
  border: none;
}

.categoryItem {
  height: 50px;
  flex: 1;
  text-align: center;
}

.yqlj {
  display: block;
}

</style>
